import React from "react";

export interface SelectableCardOption {
  value: string;
  title: string;
  subtitle?: string;
  description?: string | null;
}

interface SelectableCardGroupProps {
  name: string;
  label?: string;
  options: SelectableCardOption[];
  value: string;
  onChange: (value: string) => void;
  error?: string;
  touched?: boolean;
}

// A radio group rendered as cards; only one option can be selected.
const SelectableCardGroup: React.FC<SelectableCardGroupProps> = ({
  name,
  label,
  options,
  value,
  onChange,
  error,
  touched,
}) => {
  return (
    <div className="selectable-card-group">
      {label && <label className="selectable-card-group__label">{label}</label>}

      <div className="selectable-card-group__list" role="radiogroup">
        {options.map((option) => {
          const isSelected = option.value === value;
          return (
            <label
              key={option.value}
              className={`selectable-card${isSelected ? " selectable-card--selected" : ""}`}
            >
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={isSelected}
                onChange={() => onChange(option.value)}
                className="selectable-card__radio"
              />
              <div className="selectable-card__content">
                <div className="selectable-card__title">{option.title}</div>
                {option.subtitle && (
                  <div className="selectable-card__subtitle">{option.subtitle}</div>
                )}
                {option.description && (
                  <div className="selectable-card__description">
                    {option.description}
                  </div>
                )}
              </div>
            </label>
          );
        })}
      </div>

      {touched && error && (
        <div className="error-line">
          <span>{error}</span>
        </div>
      )}
    </div>
  );
};

export default SelectableCardGroup;
